import { Component, OnInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';

@FormComponentLookup('text-area')
@Component({
    selector: 'app-text-area',
    templateUrl: './text-area.component.html',
    styleUrls: ['./text-area.component.scss'],
    standalone: false
})
export class TextAreaComponent extends FormEntryComponentClass implements OnInit {

  constructor() { 
    super();
  }

  ngOnInit(): void {
  }

}
